import type { CityConfig } from "../city-template/types";

export const warrensburgMOConfig: CityConfig = {
  city: "Warrensburg",
  state: "Missouri",
  stateAbbr: "MO",
  slug: "warrensburg-mo",
  route: "/cities/warrensburg-mo",
  title: "Emergency Passport Warrensburg, MO — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Warrensburg, MO — as fast as 24 hours. Serving Johnson County and the UCM community. A+ BBB rated registered State Dept. courier serving Warrensburg, Knob Noster, Whiteman AFB, and west-central Missouri. No office visit required.",
  h1: "Emergency & Expedited Passport Services in Warrensburg, MO",
  heroSubtitle: "University of Central Missouri students studying abroad next week? Whiteman AFB family PCS to Germany with urgent passport needs? Johnson County business trip to Tokyo and documents expired? We help Warrensburg residents get their passports fast — as fast as 24 hours. A+ BBB rated registered State Dept. courier. Best price guarantee. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Aerial%20view%20of%20Warrensburg%20Missouri%20Johnson%20County%20University%20of%20Central%20Missouri%20campus%20historic%20downtown%20courthouse%20square%20academic%20college%20town%20midwestern%20landscape%20green%20quads%20red%20brick%20university%20buildings%20tree%20lined%20streets%20soft%20afternoon%20light%20professional%20drone%20photography%20Heartland%20education%20hub&width=1800&height=700&seq=warrensburg-mo-hero-2026&orientation=landscape",
  heroImageAlt: "Warrensburg Missouri University of Central Missouri campus and historic downtown at afternoon light",
  geoPosition: "38.7626;-93.7354",
  geoPlacename: "Warrensburg, Missouri",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "101 Ida B. Wells Drive, 9th Floor, Chicago, IL 60604",
    distance: "Located in downtown Chicago — approximately 505 miles northeast of Warrensburg via I-70/I-55",
  },
  nearbyCitiesZips: [
    { name: "Warrensburg", zips: "64093" },
    { name: "Kansas City", zips: "64101–64199" },
    { name: "Knob Noster", zips: "65336" },
    { name: "Holden", zips: "64040" },
    { name: "Higginsville", zips: "64037" },
    { name: "Odessa", zips: "64076" },
    { name: "Concordia", zips: "64020" },
    { name: "Lexington", zips: "64067" },
    { name: "Centerview", zips: "64019" },
    { name: "Chilhowee", zips: "64733" },
    { name: "Blairstown", zips: "64726" },
    { name: "Sedalia", zips: "65301, 65302" },
    { name: "Whiteman AFB", zips: "65305" },
    { name: "Windsor", zips: "65360" },
    { name: "Kingsville", zips: "64061" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Johnson County departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-map-pin-2-line", title: "UCM & Whiteman Hub", desc: "Serving UCM students, military families, and Johnson County" },
  ],
  internalLinks: [
    { name: "Expedited passport services in Kansas City, MO", route: "/cities/kansas-city" },
    { name: "Fast passport renewal in Lee's Summit, MO", route: "/cities/lees-summit" },
    { name: "Emergency passport help in Columbia, MO", route: "/cities/columbia-mo" },
    { name: "Urgent passport services in Independence, MO", route: "/cities/independence-mo" },
    { name: "Same-day passport help in Chicago, IL", route: "/cities/chicago" },
    { name: "Passport courier services in Jefferson City, MO", route: "/cities/jefferson-city" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Warrensburg remotely via secure courier. We do not have a walk-in office in Warrensburg — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Johnson County, UCM students, and Whiteman AFB personnel.",
  fpcOfficeAddress: "1200 Main St, Kansas City, Missouri 64105",
  fpcOfficeDistance: "Serving all of Johnson County including Warrensburg, Knob Noster, Whiteman AFB, Holden, and surrounding communities",
  serviceAreaIntro: "From the University of Central Missouri campus and the historic courthouse square of Warrensburg to the B-2 stealth bomber base at Whiteman AFB, from the railroad town of Knob Noster to the farming communities of Holden and Higginsville — Fast Passport Center serves the entire Johnson County and west-central Missouri region. We regularly help UCM international students, military families, and Johnson County travelers get their passports fast without the 7-hour drive to Chicago.",
  nearbyCitiesIntro: "We serve all Warrensburg neighborhoods and the surrounding Johnson County area including Knob Noster, Whiteman AFB, Holden, Higginsville, Odessa, and Sedalia. If you are anywhere in Johnson County or west-central Missouri, we have you covered.",
  howItWorksIntro: "Most Warrensburg travelers complete everything online and ship documents overnight. No need to drive to Chicago or wait in line at the regional agency.",
  mistakesIntro: "Warrensburg travelers often face a 7-hour drive to the nearest regional passport agency in Chicago. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Warrensburg and Johnson County travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Warrensburg? Here are the most common ones we hear from Johnson County travelers.",
  statePageRoute: "/states/missouri",
  statePageName: "Missouri",
  dmvWebsite: "https://dor.mo.gov/drivers/",
  dmvLabel: "Missouri DOR — Driver License Bureau",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Warrensburg travelers with immediate departure needs — as fast as 24 hours for urgent international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-bank-card-line",
      title: "Passport Card",
      description: "Wallet-sized U.S. Passport Card for land and sea travel to Canada, Mexico, Bermuda, and the Caribbean.",
      bullets: ["REAL ID compliant alternative", "Fits in your wallet", "Land/sea border crossing approved"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
    {
      icon: "ri-error-warning-line",
      title: "Damaged Passport",
      description: "Replacement for water-damaged, torn, or otherwise mutilated passports that are no longer valid for travel.",
      bullets: ["Damage assessment guidance", "DS-11 replacement process", "Supporting documentation help"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-file-copy-line",
      title: "Second Passport",
      description: "Obtain a second valid U.S. passport for frequent international travelers who need overlapping visas.",
      bullets: ["For frequent business travelers", "Overlapping visa support", "Expedited processing available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
    { name: "Passport Card", description: "Wallet-sized U.S. Passport Card for land and sea travel to Canada, Mexico, Bermuda, and the Caribbean." },
    { name: "Damaged Passport", description: "Replacement for water-damaged, torn, or mutilated passports requiring DS-11 replacement." },
    { name: "Second Passport", description: "Second valid U.S. passport for frequent international travelers with overlapping visa needs." },
  ],
  testimonials: [
    {
      name: "Amanda P.",
      location: "Warrensburg, MO",
      rating: 5,
      text: "I'm a UCM grad student and my semester abroad in Madrid started in 5 days when I realized my passport was expired. Fast Passport Center got my renewal in 27 hours. From the UCM quad to the Plaza Mayor in under a week — unbelievable!",
      service: "Passport Renewal",
    },
    {
      name: "Capt. James R.",
      location: "Whiteman AFB, MO",
      rating: 5,
      text: "PCS orders to Ramstein with tight timeline. Fast Passport Center handled my family's expedited passports for all 4 of us. The dedicated agent understood military timelines. Outstanding service for Whiteman personnel.",
      service: "Emergency Passport",
    },
    {
      name: "Diane K.",
      location: "Warrensburg, MO",
      rating: 5,
      text: "Both kids needed first passports for a school trip to France. Fast Passport Center walked us through everything. From Johnson County to the Eiffel Tower. Cannot recommend highly enough for UCM and Warrensburg families!",
      service: "Child Passport",
    },
  ],
  facilities: [
    {
      id: "warrensburg-1",
      name: "Warrensburg Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "215 E Culton St",
      city: "Warrensburg",
      state: "MO",
      zip: "64093",
      phone: "(660) 747-2111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Warrensburg",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Warrensburg facility. Appointments strongly recommended. Call ahead to confirm passport acceptance hours.",
      icon: "ri-mail-line",
    },
    {
      id: "warrensburg-2",
      name: "Johnson County Circuit Clerk",
      type: "County Government Passport Acceptance",
      address: "300 N Holden St",
      city: "Warrensburg",
      state: "MO",
      zip: "64093",
      phone: "(660) 747-6811",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "Downtown Warrensburg Courthouse",
      website: "https://www.jococourthouse.com",
      websiteLabel: "Johnson County Circuit Clerk",
      notes: "County seat with passport acceptance services. Good alternative to post office. Appointment recommended.",
      icon: "ri-government-line",
    },
    {
      id: "warrensburg-3",
      name: "Knob Noster Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "102 S Monroe Ave",
      city: "Knob Noster",
      state: "MO",
      zip: "65336",
      phone: "(660) 563-2111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "10 miles east of Warrensburg",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Knob Noster and Whiteman AFB area. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "warrensburg-4",
      name: "Sedalia Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "405 E 5th St",
      city: "Sedalia",
      state: "MO",
      zip: "65301",
      phone: "(660) 826-2111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "25 miles east of Warrensburg",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Larger facility serving Pettis County. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "warrensburg-5",
      name: "Holden Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "101 W 2nd St",
      city: "Holden",
      state: "MO",
      zip: "64040",
      phone: "(816) 732-2111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "12 miles west of Warrensburg",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Holden area. Appointment recommended.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 7 hour drive to Chicago", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Warrensburg photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Johnson County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Warrensburg applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the Chicago regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many UCM student families and Johnson County residents.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Warrensburg travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Warrensburg." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Warrensburg address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Warrensburg before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Warrensburg for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround — without the 7-hour drive to Chicago." },
    { q: "How fast can I renew my passport in Warrensburg?", a: "Fast Passport Center offers fast passport renewal in Warrensburg in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What is the closest passport agency to Warrensburg?", a: "The nearest regional passport agency to Warrensburg is the Chicago Passport Agency, approximately 505 miles northeast via I-70/I-55. For urgent processing without the long drive, Fast Passport Center's registered courier service achieves 24–48 hour turnaround from Warrensburg without any in-person agency visit required." },
    { q: "Can I get a same-day passport appointment near Warrensburg?", a: "Same-day passport appointments are only available at the Chicago Regional Passport Agency — approximately 7 hours from Warrensburg — for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for Johnson County and UCM community residents." },
    { q: "Do you serve Whiteman AFB and military families?", a: "Absolutely. Fast Passport Center proudly serves Whiteman Air Force Base personnel and military families in the Warrensburg/Knob Noster area. Our courier service works seamlessly for PCS orders, deployment travel, and military family passport needs." },
    { q: "Can I expedite a child passport in Warrensburg?", a: "Yes. Fast Passport Center expedites child passports in Warrensburg for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Johnson County and UCM families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Warrensburg with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "Do I need to drive to the Chicago Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
  ],
  photoLocations: [
    { name: "Walmart Supercenter — Warrensburg", address: "301 E Cooper Blvd, Warrensburg, MO 64093", hours: "Mon–Sun: 6AM–11PM" },
    { name: "Walgreens — Warrensburg", address: "615 N Maguire St, Warrensburg, MO 64093", hours: "Mon–Sun: 7AM–11PM" },
    { name: "CVS Pharmacy — Sedalia", address: "3100 W Broadway Blvd, Sedalia, MO 65301", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walmart Supercenter — Higginsville", address: "3039 N Main St, Higginsville, MO 64037", hours: "Mon–Sun: 6AM–11PM" },
  ],
  dmvLocations: [
    {
      name: "Missouri DOR — Warrensburg License Office",
      address: "136 N Holden St, Warrensburg, MO 64093",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Driver license and REAL ID services. Most convenient for Warrensburg residents and UCM students.",
      featured: true,
    },
    {
      name: "Missouri DOR — Sedalia License Office",
      address: "3401 W 10th St, Sedalia, MO 65301",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Pettis County. REAL ID available. Appointment recommended.",
      featured: false,
    },
    {
      name: "Missouri DOR — Odessa License Office",
      address: "100 W Mason St, Odessa, MO 64076",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves western Johnson County and Lafayette County. REAL ID available.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "MCI",
      name: "Kansas City International Airport",
      distance: "75 miles northwest of Warrensburg",
      address: "1 Kansas City Blvd, Kansas City, MO 64153",
      note: "Major international airport with direct flights worldwide. About 1 hour 15 minutes from Warrensburg via US-50/I-435.",
      flightUrl: "https://www.flykc.com/",
      flightLabel: "MCI Airport",
      featured: true,
    },
    {
      code: "SZL",
      name: "Whiteman AFB Airfield",
      distance: "12 miles east of Warrensburg",
      address: "Whiteman AFB, Knob Noster, MO 65305",
      note: "Military airfield for Whiteman AFB personnel. About 20 minutes from Warrensburg. Military travel only.",
      flightUrl: "https://www.whiteman.af.mil/",
      flightLabel: "Whiteman AFB",
      featured: false,
    },
    {
      code: "STL",
      name: "St. Louis Lambert International Airport",
      distance: "200 miles east of Warrensburg",
      address: "10701 Lambert International Blvd, St. Louis, MO 63145",
      note: "Major international airport with worldwide connections. About 3 hours from Warrensburg via I-70.",
      flightUrl: "https://www.flystl.com/",
      flightLabel: "STL Airport",
      featured: false,
    },
  ],
};